import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService, HttpBaseService, LocalizationService, NotifyService } from '@app/core';
import { ApiControllerEnum, EntityStateEnum } from '@app/shared/common/enums';
import { RatingListItem } from '../models/rating-list-item';
import { Observable } from 'rxjs';
import { RatingFormItem } from '../models/rating-form-item';

@Injectable({
  providedIn: 'root'
})
export class RatingService extends HttpBaseService {
  constructor(private http: HttpClient
    , private notifyServ: NotifyService
    , private localizationService: LocalizationService
    , private configService: ConfigurationService) {
    super(http, ApiControllerEnum.Rating, notifyServ, localizationService, configService);
}

getDataByFilter(filter: any): Observable<RatingListItem> {
  return this.post("GetDataByFilter", filter, true);
}

addRatingWithAvg(obj: any): Observable<any> {
  obj.entityState = EntityStateEnum.Added;
  return this.post("SaveWithAvgAsync", obj, true);
}

updateRatingWithAvg(obj: any): Observable<any> {
  obj.entityState = EntityStateEnum.Modified;
  return this.post("SaveWithAvgAsync", obj, true);
}

}
